import React from 'react'

const ManagerWFContext = React.createContext({
  ExpInfo: {},
  updateExpInfo: () => {},
})

export default ManagerWFContext
